import React from 'react';

import { BulkFulfillmentPlanTagDropdownBodyEmpty } from './bulk-tag-dropdown-body-empty';
import { useFulfillmentPlanTagsContext } from './tag-context';
import { BulkFulfillmentPlanTagDropdownFooter } from './bulk-tag-dropdown-footer';
import { BulkFulfillmentPlanTagDropdownBody } from './bulk-tag-dropdown-body';

export const BulkFulfillmentPlanTagDropdownContent = () => {
  const { isEmptyTagList } = useFulfillmentPlanTagsContext();

  if (isEmptyTagList) {
    return <BulkFulfillmentPlanTagDropdownBodyEmpty />;
  }

  return (
    <>
      <BulkFulfillmentPlanTagDropdownBody />
      <BulkFulfillmentPlanTagDropdownFooter />
    </>
  );
};
